import React from 'react';
import type { OtherRadioButtonProps } from '../interfaces';
import RadioButtonListItem from './radio-button-list-item';

class OtherRadioButton extends React.PureComponent<OtherRadioButtonProps> {
  private static whiteList = ['Allowed with Explanation', 'Allowed'];

  render() {
    if (!OtherRadioButton.whiteList.includes(this.props.other)) {
      return null;
    }

    const { onChange, active, viewMode, readOnly, name } = this.props;

    return (
      <RadioButtonListItem
        key={'other'}
        active={active}
        viewMode={viewMode}
        readOnly={readOnly}
        text={'Other'}
        value={'Other'}
        onChange={onChange}
        name={name}
      />
    );
  }
}

export default OtherRadioButton;
